<!-- MOTIVAZIONE DI MANCATA RIPOSTA PER MODULO BASE -->
<div>
  <section class="giustifica-section">
    <mat-checkbox
      [disabled]="readOnly()"
      #nonDisponibileChk
      [(ngModel)]="sottoRisposta().infoNonDisponibile!.checked"
      (ngModelChange)="toggleEsclusivo('disponibile')"
    >
      <span class="titolo-checkbox"> Dato o informazione non disponibile </span>
    </mat-checkbox>
    <span class="descrizione-checkbox">
      Si prega di dettagliare la risposta e di fornire un orizzonte temporale entro il quale il dato
      sarà disponibile
    </span>
    @if (nonDisponibileChk.checked) {
      <div appFormContainer [larghezza]="3" class="cnt-motivazione">
        <mat-form-field [larghezza]="2" appFormElement>
          <mat-label>Spiega perché il dato non è disponibile</mat-label>
          <textarea
            #textArea
            matInput
            [placeholder]="'Risposta...'"
            rows="4"
            [(ngModel)]="sottoRisposta().infoNonDisponibile!.risposta"
            [disabled]="readOnly()"
            [required]="isRequired() && isPMI() && !sottoRisposta().moduloCompleto"
            [appForceErrorView]="showTouchedField()"
          ></textarea>
          <mat-error appFormError></mat-error>
        </mat-form-field>
      </div>
    }
    <mat-checkbox
      [disabled]="readOnly()"
      #nonRilevanteChk
      [(ngModel)]="sottoRisposta().infoNonRilevante!.checked"
      (ngModelChange)="toggleEsclusivo('rilevante')"
    >
      <span class="titolo-checkbox"> Dato o informazione non rilevante </span>
    </mat-checkbox>
    <span class="descrizione-checkbox">
      Si prega di dettagliare la risposta e di fornire una descrizione dei criteri di non rilevanza
      del dato e dell’informazione.
    </span>
    @if (nonRilevanteChk.checked) {
      <div appFormContainer [larghezza]="3" class="cnt-motivazione">
        <mat-form-field [larghezza]="2" appFormElement>
          <mat-label>Spiega perché il dato non è rilevante</mat-label>
          <textarea
            #textArea
            matInput
            [placeholder]="'Risposta...'"
            rows="4"
            [(ngModel)]="sottoRisposta().infoNonRilevante!.risposta"
            [disabled]="readOnly()"
            [required]="isRequired() && isPMI() && !sottoRisposta().moduloCompleto"
            [appForceErrorView]="showTouchedField()"
          ></textarea>
          <mat-error appFormError></mat-error>
        </mat-form-field>
      </div>
    }
  </section>
</div>
